<template>
  <div
    class="container-fluid blog py-2"
    style="
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center; /* 垂直居中 */
    "
  >
    <div style="width: 100%; margin: 30px 0px">
      <h1 class="title">服务网点</h1>
      <div
        v-if="spinValue"
        style="display: flex; justify-content: center; align-items: center"
      >
        <a-spin>
          <a-icon slot="indicator" type="loading" style="font-size: 20px" />
        </a-spin>
      </div>
      <div v-else class="point_name">
        {{ servicePointList[0].title }}
      </div>
      <div style="margin: 20px 50px 0px 50px">
        <div class="map">
          <TdtServicePointMap
            v-if="!spinValue && servicePoint"
            :tk="tk"
            :center="servicePointCenter"
            :zoom="17"
            :markers="servicePointMarkers"
          />
        </div>
      </div>
    </div>
    <div class="form_background">
      <div
        v-if="spinValue"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          height: 500px;
        "
      >
        <a-spin>
          <a-icon slot="indicator" type="loading" style="font-size: 30px" />
        </a-spin>
      </div>
      <!-- 基础信息 -->
      <a-collapse v-else :bordered="false" accordion @change="changeActivekey">
        <template #expandIcon="props">
          <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
        </template>
        <a-collapse-panel
          v-for="item in servicePointList"
          :key="item.id"
          :header="item.title"
          :style="customStyle"
        >
          <div class="col-md-12" style="margin-bottom: 12px">
            <span
              style="
                font-size: 14px;
                color: #acabbd;
                font-family: Microsoft YaHei;
              "
            >
              联系人：
            </span>
            <span
              style="
                font-size: 14px;
                color: black;
                font-family: Microsoft YaHei;
              "
            >
              {{ item.linkMan }}
            </span>
          </div>
          <div class="col-md-12" style="margin-bottom: 12px">
            <span
              style="
                font-size: 14px;
                color: #acabbd;
                font-family: Microsoft YaHei;
              "
            >
              联系电话：
            </span>
            <span
              style="
                font-size: 14px;
                color: black;
                font-family: Microsoft YaHei;
              "
            >
              <img
                src="@/assets/callPhone.png"
                style="height: 18px; margin-bottom: 2px; margin-right: 6px"
                alt=""
              />
              <span style="color: #04b910">{{ item.serviceLandline }}</span>
            </span>
          </div>
          <div class="col-md-12" style="margin-bottom: 12px">
            <span
              style="
                font-size: 14px;
                color: #acabbd;
                font-family: Microsoft YaHei;
              "
            >
              服务点地址：
            </span>
            <span
              style="
                font-size: 14px;
                color: black;
                font-family: Microsoft YaHei;
              "
            >
              <img
                src="@/assets/toAddress.png"
                style="height: 18px; margin-bottom: 2px; margin-right: 6px"
                alt=""
              />
              <span style="color: #0060c9">{{ item.address }}</span>
            </span>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>
  </div>
</template>
<script>
import { listServicePoint } from "@/api/common/Common.js";
import TdtServicePointMap from "@/components/TdtServicePointMap.vue";
export default {
  components: {
    TdtServicePointMap,
  },

  data() {
    return {
      tk: "a3789da931616fce36077d6fd5712667",
      labelCol: { span: 4 },
      wrapperCol: { span: 19 },
      customStyle:
        "background: rgb(255 255 255/var(--tw-bg-opacity));border-radius: 4px;border: 2;overflow: hidden",
      servicePointList: [],
      spinValue: true,
      servicePoint: {
        address: "",
        longitude: 121.165666,
        latitude: 30.886314,
        linkMan: "",
        serviceLandline: "",
        title: "",
      },
    };
  },
  computed: {
    servicePointCenter() {
      return [
        Number(this.servicePoint.longitude || 121.165666),
        Number(this.servicePoint.latitude || 30.886314),
      ];
    },

    servicePointMarkers() {
      if (!this.servicePoint) {
        return [];
      }

      return [
        {
          id: this.servicePoint.id,
          lng: Number(this.servicePoint.longitude),
          lat: Number(this.servicePoint.latitude),
          icon: require("@/assets/locationMap.png"),
          servicePic: require("@/assets/zhujinge.jpg"),
          data: {
            title: this.servicePoint.title,
            linkMan: this.servicePoint.linkMan,
            serviceLandline: this.servicePoint.serviceLandline,
            address: this.servicePoint.address,
          },
        },
      ];
    },
  },

  mounted() {
    listServicePoint().then((res) => {
      if (res.code == "200") {
        this.servicePointList = res.data || [];
        this.servicePoint = this.servicePointList[0] || this.servicePoint;
        this.spinValue = false;
      }
    });
  },

  methods: {
    changeActivekey(key) {
      this.servicePoint = this.servicePointList.find((item) => item.id == key);
      this.initMap();
    },
  },
};
</script>

<style lang="less" scoped>
.ant-pro-components-tag-select {
  /deep/ .ant-pro-tag-select .ant-tag {
    margin-right: 24px;
    padding: 0 8px;
    font-size: 14px;
  }
}

.list-articles-trigger {
  margin-left: 12px;
}

.title {
  --tw-text-opacity: 1;
  color: rgb(29 29 29 / var(--tw-text-opacity));
  justify-content: center;
  display: flex;
  font-weight: 600;
  font-size: 50px;
}

.point_name {
  --tw-text-opacity: 1 !important;
  color: rgb(29 29 29 / var(--tw-text-opacity)) !important;
  font-weight: 600 !important;
  justify-content: center;
  display: flex;
  margin-top: 30px;
  font-size: 20px;
}

.form_background {
  width: 70%;
  margin: 30px 0px;
  border-radius: 1rem;
  border-width: 0;
  --tw-border-opacity: 1;
  border-top: 8px #007aff;
  border-style: solid;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding: 3rem;
  --tw-shadow: 0px 20px 25px -5px rgba(64, 63, 118, 0.1),
    0px 10px 10px -5px rgba(64, 63, 118, 0.04);
  --tw-shadow-colored: 0px 20px 25px -5px var(--tw-shadow-color),
    0px 10px 10px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
</style>

<style lang="less" scope>
.map {
  #container {
    border-radius: 4px;
    padding: 0px;
    margin: 0px;
    margin-top: 20px;
    width: 100%;
    height: 500px;
  }
}
</style>